import React from 'react';
import clsx from 'clsx';
import { Button as ButtonAntd, ButtonProps as ButtonAntdProps } from 'antd';
import type { CoreHTMLProps, Size } from '../../shared/interface';
import styles from './Button.module.scss';
export interface ButtonProps extends ButtonAntdProps {
  className?: string;
  label?: string;
}

export interface ButtonStyleProps extends Pick<CoreHTMLProps, 'className'> {
  /**
   * Is this the principal call to action on the page?
   */
  type?: ButtonProps['type'] | 'toggle';
  /**
   * What alertType to use
   */
  alertType?: 'success' | 'positive' | 'warning' | 'danger' | 'info';
  /** Use .delete instead of .button */
  delete?: boolean;
  /**
   * How large should the button be?
   */
  size?: Size;
}

const Button = React.forwardRef<
  HTMLAnchorElement | HTMLButtonElement,
  ButtonProps
>((props, ref) => {
  const { className, children, label, onClick, ...rest } = props;
  const onClickOverride = React.useCallback(
    (e) => {
      e.target.parentNode.blur();
      onClick?.(e);
    },
    [onClick]
  );
  return (
    <ButtonAntd
      {...rest}
      ref={ref}
      className={clsx(styles.override, className)}
      onClick={onClickOverride}
    >
      {label ?? children}
    </ButtonAntd>
  );
});

Button.displayName = 'Button';

export default Button;
